<template>
<div :style="fitHeight ? 'height:100%;' : null">
  <!-- toolbawr -->
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div v-if="isEventKedbView" class="setting-addel mr-r4">
        <el-button size="mini" @click="addKedb"><i class="fas fa-plus"></i></el-button>
        <el-button size="mini" :disabled="isAbleDelete" @click="deleteKedb"><i class="fas fa-minus"></i></el-button>
      </div>
      <el-select class="mr-r10" v-model="searchSortType" style="width:80px" @change="changeSortType">
        <el-option v-for="item in searchSortTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-popover ref ="kedbPopover" placement="right" width="350" v-model="clickFilterRsc">
        <div v-for="(item, index) in relationRscTagList" class="tit c-pointer" :key="index" :label="item.label" :value="item.label">
          <span @click="clickRscItem(item)">{{item.label}} ({{item.COUNT}})</span>
        </div>
        <el-tag slot="reference" class="c-pointer" :closable="!isTotalSearch" @close="closeRsc">{{rscNameField}}</el-tag>
      </el-popover>
    </div>
    <div class="vertical-center-box">
      <el-select class="mr-r4" v-model="searchType" style="width:150px">
        <el-option v-for="item in searchTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <w-search-field width="250px" ref="searchField" @search="setSearchValue"/>
    </div>
  </el-row>
  <!-- table -->
  <el-table-wrapper :style="fitHeight ? 'height:calc(100% - 38px);' : null" ref="kedbTable" :fit-height="fitHeight" v-loading="loading" :data="kedbData" :columns="kedbColumns" :total="totalCount" remote @selection-change="kedbSelectionChange"
   :show-custom-header="false" :show-search-tool="false" @condition-change="loadData" :pagination="true" :column-default="columnDefault">
   <template slot-scope="scope" slot="kedb-title-slot">
     <span class="link c-pointer" @click="showKedbDetailView(scope.row)">{{scope.row.title}}</span>
   </template>
  </el-table-wrapper>
  <w-kedb-add-popup v-if="isEventKedbView" popupType="ADD" ref="kedbAddPopup" @reload="loadData"></w-kedb-add-popup>
</div>
</template>

<script>
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { isNil, isEmpty, cloneDeep, concat } from 'lodash';
import { getDateToString } from '@/utils/date';
import { mapGetters } from 'vuex';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import WSearchField from '@/components/form/SearchField';
import KedbAPI from '@/api/event/kedb';
import WKedbAddPopup from './popup/KedbAddPopup';

export default {
  name: 'WKedbTable',
  components: {
    WKedbAddPopup,
    WSearchField,
  },
  props: {
    // KEDB 조회 테이블이 팝업에서 보여지는지 아닌지 판단
    viewType: {
      type: String,
    },
    // 상세 조회에서 필터링 조건을 선택한 경우
    filterTag: {
      type: Object,
    },
    /**
     * 높이를 컨테이너의 높이에 맞출지 설정한다.
     * true면 컨테이너의 높이에 맞추며, false는 컨텐츠 크기에 따라 가변적으로 높이가 설정되도록 한다.
     */
    fitHeight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      getValueAfterCheckEmpty,
      columnDefault,
      searchType: 'total',
      searchSortType: 'recentSort',
      totalCount: 0,
      searchValue: null,
      kedbData: null,
      clickFilterRsc: false,
      selectRelationRsc: null,
      selectionKedbRow: [],
      isAbleDelete: true,
      relationRscTagList: [],
      searchSortTypeOption: [
        {
          value: 'recentSort',
          label: '최신순',
        },
        {
          value: 'recommendSort',
          label: '추천순',
        },
      ],
      kedbColumns: [
        { prop: 'seqNumber', label: 'No', width: 55 },
        { prop: 'title', label: '제목', scopedSlot: 'kedb-title-slot' },
        { prop: 'writerId', label: '작성자', width: '130px' },
        { prop: 'writeDatetime', label: '작성일시', width: '130px', formatter: this.getDateFormatter },
        { prop: 'recommendCount', label: '추천수', width: '70px', align: 'center', headerAlign: 'center' },
        { prop: 'viewCount', label: '조회수', width: '70px', formatter: this.checkEmptyValue, align: 'center', headerAlign: 'center' },
      ],
      searchTypeOption: [
        {
          value: 'total',
          label: '전체',
        },
        {
          value: 'title',
          label: '제목',
        },
        {
          value: 'errorSymptom',
          label: '장애증상',
        },
        {
          value: 'errorSolution',
          label: '조치방법',
        },
      ],
      /**
       * KEDB 목록 조회 시 사용된 파라미터 관리 객체
       * @type {Object}
       */
      kedbParams: null,
    };
  },
  computed: {
    /**
     * 계정 어드민 권한 여부
     * @author yelim
     * @return {Boolean}
     */
    isAdmin() {
      return this.userInfo.managerType === 'ADMIN';
    },
    /**
     * KEDB 목록은 이벤트탭에서 제공되거나, 장애티켓의 연관 KEDB 추가 팝업으로 확인할 수 있음
     * 해당 변수는 이벤트 탭의 상단부 KEDB 버튼을 통해 목록을 조회하는지 판단하는 변수이다.
     * @author yelim
     */
    isEventKedbView() {
      if (this.viewType === 'kedbPopup' && this.isAdmin) {
        return true;
      }
      return false;
    },
    isEtcSearch() {
      return (!isNil(this.selectRelationRsc) && this.selectRelationRsc.isEtcSearch === 1);
    },
    // 선택된 항목이 존재하지 않는 경우 cloasble = false
    isTotalSearch() {
      return isNil(this.selectRelationRsc);
    },
    /**
     * 필터링 조건이 존재하는 경우, 해당 태그의 라벨을 보여주며 아닌 경우 전체로 설정한다.
     * @author yelim
     */
    rscNameField() {
      return isNil(this.selectRelationRsc) ? '전체' : this.selectRelationRsc.label;
    },
    ...mapGetters(['userInfo']),
  },
  watch: {
    /**
     * 이벤트탭 상단부 KEDB 버튼을 통해 목록이 조회되고, 조회한 대상이 admin 계정인 경우 삭제를 위한 체크박스 컬럼을 제공한다.
     * @author yelim
     */
    viewType: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value)) {
          this.loadData();
          this.loadRelationRscTag();
        }
      },
    },
    /**
     * 화면 전환 도중 계정 타입이 바뀌는 경우를 대비
     */
    isAdmin: {
      immediate: true,
      handler(value) {
        this.addCheckColumn(value);
      },
    },
    /**
     * 상세 조회에서 필터링 조건을 선택한 경우, KEDB 목록의 조회 조건을 추가한다.
     */
    filterTag: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value)) {
          this.selectRelationRsc = value;
          this.loadPage(1);
          this.loadRelationRscTag();
        }
      },
    },
  },
  methods: {
    /**
     * KEDB 목록을 태그, 검색 조건에 따라 조회한다.
     * @author yelim
     */
    loadData() {
      this.$nextTick(() => {
        const tableParams = this.$refs.kedbTable.getParameter();
        const pagination = this.$refs.kedbTable.getPagination();
        const params = {
          ...tableParams,
          pageSize: pagination.pageSize,
          searchSortType: this.searchSortType,
          searchType: this.searchType,
        };
        // 검색조건이 존재하는 경우
        if (!isNil(this.searchValue) && this.searchValue !== '') {
          params.searchValue = this.searchValue;
        }
        // 태그 조건이 존재하는 경우
        if (!isNil(this.selectRelationRsc)) {
          params.isEtcSearch = this.isEtcSearch;
          params.managetypeId = this.selectRelationRsc.managetypeId;
          params.rsctypeId = this.selectRelationRsc.rsctypeId;
          params.rscId = this.selectRelationRsc.rscId;
        }
        this.loading = true;
        KedbAPI.getKedbList(params).then((response) => {
          if (response.data.success) {
            this.kedbParams = params;
            if (isEmpty(response.data.data) && response.data.total !== 0) {
              this.loadPage(response.data.lastPage);
            } else {
              this.kedbData = response.data.data;
              this.totalCount = response.data.total;
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'KEDB 목록', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'KEDB 목록', false));
          throw new Error(e);
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    changeSortType() {
      this.loadPage(1);
    },
    /**
     * KEDB 특정 페이지를 로드한다.
     * @author Ju
     * @param  {Number} page 페이지 수
     */
    loadPage(page) {
      if (this.$refs.kedbTable) {
        this.$refs.kedbTable.setCurrentPage(page);
      } else {
        this.$nextTick(() => {
          this.$refs.kedbTable.setCurrentPage(page);
        });
      }
    },
    /**
     * 연관자원 목록을 조회한다. 검색어 조건이 걸려있는 경우 포함하여 조회한다.
     * @author yelim
     */
    loadRelationRscTag() {
      const params = {
        searchType: this.searchType,
      };
      if (!isNil(this.searchValue) && this.searchValue !== '') {
        params.searchValue = this.searchValue;
      }
      KedbAPI.getRelationRscList(params).then((response) => {
        if (response.data.success) {
          this.relationRscTagList = cloneDeep(response.data.data);
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '연관자원 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '연관자원 목록', false));
        throw new Error(e);
      });
    },
    /**
     * Date formatter
     * @author yelim
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    /**
     * KEDB 추가 팝업을 연다.
     * @author yelim
     */
    addKedb() {
      this.$refs.kedbAddPopup.open();
    },
    /**
     * 조회 버튼을 누르면 검색어 조건이 설정된다.
     * @author yelim
     */
    setSearchValue(value) {
      this.searchValue = value;
      this.loadPage(1);
      this.loadRelationRscTag();
    },
    checkEmptyValue(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    /**
     * 태그를 클릭시 선택 기준으로 KEDB 목록을 조회한다.
     * @author yelim
     */
    clickRscItem(item) {
      // 기타 카테고리로 분류 되는 경우 isEtcSearch 변수는 1로 설정된다.
      this.clickFilterRsc = false;
      this.selectRelationRsc = cloneDeep(item);
      this.loadPage(1);
      this.loadRelationRscTag();
    },
    /**
     * 태그의 X 아이콘을 클릭하면 전체 태그로 변경된다.
     * @author yelim
     */
    closeRsc() {
      this.selectRelationRsc = null;
      this.$refs.kedbPopover.showPopper = false;
      this.loadPage(1);
      this.loadRelationRscTag();
    },
    /**
     * KEDB를 삭제한다.
     * @author yelim
     */
    deleteKedb() {
      const deleteList = [];
      this.selectionKedbRow.forEach((item) => {
        deleteList.push({
          seqNumber: item.seqNumber,
        });
      });
      if (this.selectionKedbRow.length < 1) {
        this.$message(msgUtil.getCustomMsgData('삭제할 KEDB를 선택해주십시오.'));
      } else {
        this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
          KedbAPI.deleteKedbInfo(deleteList).then((response) => {
            if (response.data.success) {
              this.loadData();
              this.loadRelationRscTag();
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, 'KEDB', true));
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, 'KEDB', false));
            }
          }).catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, 'KEDB', false));
            throw new Error(e);
          });
        });
      }
    },
    /**
     * KEDB 목록에서 체크박스로 선택한 항목의 정보를 저장한다.
     * @author yelim]
     */
    kedbSelectionChange(row) {
      this.selectionKedbRow = row;
      this.isAbleDelete = !(row.length > 0);
      if (this.viewType === 'relationKedbPopup') {
        this.$emit('selection-row-change', row);
      }
    },
    /**
     * 접속 계정 권한이 ADMIN인 경우 체크 컬럼을 추가한다.
     * @author yelim
     */
    addCheckColumn(isAdmin) {
      if (isAdmin) {
        const columns = cloneDeep(this.kedbColumns);
        const concatCols = concat([{ type: 'selection', width: 55 }], columns);
        this.kedbColumns = concatCols;
      }
    },
    /**
     * 선택한 KEDB 항목의 상세정보를 조회한다.
     * @author yelim
     */
    showKedbDetailView(row) {
      const params = {
        seqNumber: row.seqNumber,
        tableParams: cloneDeep(this.kedbParams),
      };
      this.$emit('click-kedb-detail-view', params);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/kedb/components/KedbTable.vue